<!--
IconBank - a Nuxt.js NuxtContent component from Pennock Projects, MIT License, Copyright (c) 2025-2026 John Pennock
version: 1.0
-->

<template>
  <div class="icon-bank">
    <span v-if="$slots.title" class="icon-bank-title">
      <slot name="title" />
    </span>
    <span class="icon-strip not-prose">
      <span class="icon-item icon-one">
        <slot />
      </span>
      <span v-if="$slots.two" class="icon-item icon-two">
        <slot name="two" />
      </span>
      <span v-if="$slots.three" class="icon-item icon-three">
        <slot name="three" />
      </span>
      <span v-if="$slots.four" class="icon-item icon-four">
        <slot name="four" />
      </span>
      <span v-if="$slots.four" class="icon-item icon-five">
        <slot name="five" />
      </span>
      <span v-if="$slots.four" class="icon-item icon-six">
        <slot name="six" />
      </span>
    </span>
    <span v-if="$slots.caption" class="icon-strip-caption">
      <slot name="caption" />
    </span>
  </div>
</template>

<style scoped>
.icon-bank {
  @apply text-center p-2;
}
.icon-strip {
  @apply flex flex-wrap justify-center;
}
.icon-item {
  @apply p-2 w-1/3 lg:w-1/6 items-center justify-center flex;
}
.icon-item :deep(img) {
  @apply mx-auto w-3/4 h-auto max-w-24;
}
.icon-bank-title {
  @apply mt-2 block text-center text-gray-500 dark:text-gray-400;
}
.icon-bank-caption {
  @apply mt-2 block text-center text-sm text-gray-500 dark:text-gray-400;
}
</style>

<!-- .icon-item {
  @apply mx-2 h-16 w-24 items-center justify-center flex;
}
.icon-item :deep(img) {
  @apply mx-auto max-h-16 max-w-24;
} -->